export default "__VITE_ASSET__BFpHlVzQ__"